import { AfterViewInit, Component, OnInit, signal } from '@angular/core';
import { DTO } from 'shared-lib';
import { ConversationService } from './main.service';
import { ChatComponent } from './chat/chat.component';
import { LoadingService } from '../loading/loading.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../auth/auth.service';

@Component({
  selector: 'ui-chat-container',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [ChatComponent],
  standalone: true,
})
export class ConversationComponent implements AfterViewInit {
  selectedContact = signal<DTO.ContactDTO | undefined>(undefined);
  contacts = signal<DTO.ContactDTO[] | undefined>(undefined);
  isMobile: boolean = window.innerWidth < 768;
  id?: number;

  constructor(
    private conversationService: ConversationService,
    private route: ActivatedRoute,
    private loadingService: LoadingService,
    private authService: AuthService
  ) {
    window.addEventListener('resize', () => {
      this.isMobile = window.innerWidth < 768;
    });
  }

  async ngAfterViewInit() {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
    const contacts = await this.conversationService.getContacts();
    this.contacts.set(contacts);
    if (this.id) {
      this.loadingService.start();
      const contact = await this.conversationService.getContact(this.id);
      this.contacts.update(this.addContact(contact));
      this.selectedContact.set(contact);
    }
    this.loadingService.stop();
  }

  ngOnDestroy(): void {
    //
  }

  selectConversation(contact: DTO.ContactDTO) {
    this.selectedContact.set(contact);
  }

  newContact() {
    return (contacts: DTO.ContactDTO[]) => {
      for (const contact of contacts) {
        if (contact.id == this.authService.getUser()?.sub) {
          continue;
        }
        this.contacts.update(this.addContact(contact));
      }
    };
  }

  addContact(newContact: DTO.ContactDTO) {
    return (contacts: DTO.ContactDTO[] | undefined) => {
      if (!contacts) {
        return [newContact];
      }
      const contactExist = contacts.filter(
        (contact) => contact.id == newContact.id
      );
      if (contactExist.length <= 0) {
        return [newContact, ...contacts];
      }
      return contacts;
    };
  }

  newMessage(data: DTO.ChatEventDTO<DTO.MessagesDTO>) {
    this.contacts.update((contacts) => {
      return contacts?.flatMap((contact) => {
        if (contact.id == data.meta.sender.id) {
          contact.lastMessage = data.payload.content;
        }
        return contact;
      });
    });
  }
}
